<template>
  <div class="bottomVert" v-if="detailReseauxLc.listeFaces.length">
    <gmap-map
      class="infoBorder gmapMobile"
      :center="{
        lat: detailReseauxLc.latitude,
        lng: detailReseauxLc.longitude
      }"
      :zoom="12"
      :options="{
        mapTypeControlOptions: mapType,
      }"
      ref="map"
      @tilesloaded="initCarto">
      <gmap-marker
        v-for="(m, index) in detailReseauxLc.listeFaces"
        :key="index"
        :clickable="true"
        :position="{
          lat: m.latitude,
          lng: m.longitude
        }"
        @click="detailFace = m, show = true"
        :icon="icon">
      </gmap-marker>
      <gmap-marker
        v-if="markerReseauxLc.lat"
        :position="{
          lat: markerReseauxLc.lat,
          lng: markerReseauxLc.lng,
        }"
        :icon="markerReseauxLc.icon">
      </gmap-marker>
    </gmap-map>
    <app-detail-reseaux-lc-complet
        :detailReseauxLcComplet="detailFace"
        v-if="show"/>
  </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps';
import { iconColorGetter, TAILLE_ICON_GRAND } from '@/services/general/iconColorGetter';
import {
  MAP_TYPE_CONTROL_OPTIONS,
  STYLE_MAPS_POI_HIDDEN, MAP_TYPE_NAME,
} from '@/configurations/configurationCarto';
import filterLatLng from '@/services/general/gestionLatLng';
import detailReseauxLcComplet from './detailReseauxLcComplet';

export default {
  name: 'carteReseauxLc',
  components: {
    appDetailReseauxLcComplet: detailReseauxLcComplet,
  },
  props: ['detailReseauxLc', 'markerReseauxLc'],
  data() {
    return {
      detailFace: {},
      show: false,
      colorIcon: '#0062b1',
      bg: false,
      mapType: MAP_TYPE_CONTROL_OPTIONS,
      isLoadOnce: false,
    };
  },
  computed: {
    icon() {
      return iconColorGetter(this.colorIcon, TAILLE_ICON_GRAND);
    },
    google: gmapApi,
  },
  methods: {
    async levelZoom() {
      const map = await this.$refs.map.$mapPromise;
      const bounds = new google.maps.LatLngBounds();
      filterLatLng(this.detailReseauxLc.listeFaces);
      this.detailReseauxLc.listeFaces.forEach(m => {
        if (m.latitude !== 0 && m.longitude !== 0
        && m.latitude !== null && m.longitude !== null) {
          bounds.extend({ lat: m.latitude, lng: m.longitude });
        }
      });
      if (this.markerReseauxLc !== undefined && this.markerReseauxLc.lat !== undefined) {
        bounds.extend({ lat: this.markerReseauxLc.lat, lng: this.markerReseauxLc.lng });
      }
      map.fitBounds(bounds);
    },
    async initPoi() {
      const map = await this.$refs.map.$mapPromise;
      const styleMap = new google.maps.StyledMapType(STYLE_MAPS_POI_HIDDEN, {
        name: MAP_TYPE_NAME,
      });
      map.mapTypes.set('styled_map', styleMap);
    },
    async initCarto() {
      if (!this.isLoadOnce) {
        await this.initPoi();
        if (this.detailReseauxLc.listeFaces.length) {
          await this.levelZoom();
        }
        this.isLoadOnce = true;
      }
    },
  },
  async mounted() {
    if (this.detailReseauxLc.latitude === null || this.detailReseauxLc.longitude === null) {
      this.detailReseauxLc.latitude = 0;
      this.detailReseauxLc.longitude = 0;
    }
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/reseauxLc/carteReseauxLc.vue